import { render, staticRenderFns } from "./ValidationErrors.vue?vue&type=template&id=7a15f5c5&scoped=true"
import script from "./ValidationErrors.vue?vue&type=script&lang=js"
export * from "./ValidationErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a15f5c5",
  null
  
)

export default component.exports